export default __webpack_public_path__ + "static/media/background2.06aad2c9.jpeg";